import styled from 'astroturf/react'
import { useFlag } from '@calendly/feature-check-react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue700))'

import { TimezonePicker } from 'components/timezone_picker'

import TimezoneSwitch from './timezone_switch'
import _Container from "timezone-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/timezone.js?styleId=Container";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isTabletUp: useDeviceType('isTabletUp'),
    isPhone: useDeviceType('isPhone'),
    bookingAppRedesign: useFlag('booking_app_redesign', false),
    compactInline: false
  })
})

const Timezone = ({
  isFlatSpotpicker = false,
  variant = 'default',
  compactInline = false,
}) => (
  <Container isFlatSpotpicker={isFlatSpotpicker} compactInline={compactInline}>
    <TimezonePicker isFlatSpotpicker={isFlatSpotpicker} variant={variant} />
    <TimezoneSwitch />
  </Container>
)

export default Timezone
